/*
 *
 * LocalStorageProvider reducer
 *
 */

import { fromJS } from 'immutable';

import { restore } from './utils';
import {
  SAVED_PLANS_LOCALSTORAGE_KEY,
  REMOVE_SAVED_PLAN,
  UPDATE_SAVED_PLAN_NAME,
  ADD_SAVED_PLAN,
  CHECKED_SAVED_PLAN,
  SET_LAST_VERSION,
  LAST_VERSION_LOCALSTORAGE_KEY,
  SET_HAS_SEEN_NEW_FEATURES,
  HAS_SEEN_NEW_FEATURES_LOCALSTORAGE_KEY,
  SET_HAS_LOADED_OLD_PLAN,
  HAS_LOADED_OLD_PLAN_LOCALSTORAGE_KEY,
  CLOSE_PRODUCT_MESSAGE,
} from './constants';

const initialState = fromJS({
  savedPlans: fromJS(restore(SAVED_PLANS_LOCALSTORAGE_KEY) || []),
  lastVersion: restore(LAST_VERSION_LOCALSTORAGE_KEY) || null,
  hasSeenNewFeatures: restore(HAS_SEEN_NEW_FEATURES_LOCALSTORAGE_KEY) || false,
  hasLoadedOldPlan: restore(HAS_LOADED_OLD_PLAN_LOCALSTORAGE_KEY) || false,
  hasClosedProductMessage: restore(CLOSE_PRODUCT_MESSAGE) || false, 
});

function addSavedPlan(state, code, image, name, updateLastOpened, lastOpened) {
  const existingIndex = state.get('savedPlans').findIndex((p) => p.get('code') === code.toUpperCase());

  let newState = state;
  if (existingIndex > -1) {
    if (updateLastOpened) {
      newState = state.setIn(['savedPlans', existingIndex, 'lastOpened'], lastOpened);
    }
  } else {
    const list = state.get('savedPlans').push(fromJS({ name, code: code.toUpperCase(), image, lastOpened, checked: false }));
    newState = state.set('savedPlans', list);
  }

  return newState.set('savedPlans', newState.get('savedPlans').sort((a, b) => b.get('lastOpened') - a.get('lastOpened')).take(10));
}

function removeSavedPlan(state, code) {
  const list = state.get('savedPlans').filterNot((p) => p.get('code') === code);

  return state.set('savedPlans', list);
}

function updateSavedPlanName(state, code, name) {
  const indexToUpdate = state.get('savedPlans').findIndex((p) => p.get('code') === code);
  return state.setIn(['savedPlans', indexToUpdate, 'name'], name);
}

function setPlanChecked(state, code) {
  const indexToUpdate = state.get('savedPlans').findIndex((p) => p.get('code') === code);

  if (indexToUpdate >= 0) {
    return state.setIn(['savedPlans', indexToUpdate, 'checked'], !state.getIn(['savedPlans', indexToUpdate, 'checked']));
  }

  return state;
}

function localStorageProviderReducer(state = initialState, action) {
  switch (action.type) {
    case REMOVE_SAVED_PLAN:
      return removeSavedPlan(state, action.code);
    case UPDATE_SAVED_PLAN_NAME:
      return updateSavedPlanName(state, action.code, action.name);
    case ADD_SAVED_PLAN:
      return addSavedPlan(state, action.code, action.image, action.name, action.updateLastOpened, action.lastOpened);
    case CHECKED_SAVED_PLAN:
      return setPlanChecked(state, action.code);
    case SET_LAST_VERSION:
      return state.set('lastVersion', action.version);
    case SET_HAS_SEEN_NEW_FEATURES:
      return state.set('hasSeenNewFeatures', action.hasSeen);
    case SET_HAS_LOADED_OLD_PLAN:
      return state.set('hasLoadedOldPlan', action.hasLoaded);
    case CLOSE_PRODUCT_MESSAGE:
      return state.set('hasClosedProductMessage', action.hasClosed);
    default:
      return state;
  }
}

export default localStorageProviderReducer;
